import { Component, OnInit, Output, EventEmitter, Inject } from '@angular/core';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogTitle } from '@angular/material/dialog';

/*Services*/
import { MatIcon } from '@angular/material/icon';
import { MatCheckbox } from '@angular/material/checkbox';

@Component({
    standalone: true,
    selector: 'app-ntm-alert-confirm',
    templateUrl: './alert-confirm.component.html',
    styleUrls: ['./alert-confirm.component.css'],
    imports: [MatIcon, MatDialogTitle, MatCheckbox]
})

export class AlertConfirmComponent implements OnInit {
  @Output()
  change: EventEmitter<string> = new EventEmitter<string>();

  mensagem: any;
  status: any;
  color: any;

  alert_type_1: any = false;
  alert_type_2: any = false;

  dataToDelete: any;
  dialogMessage: string;
  constructor(
    public dialogRef: MatDialogRef<AlertConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    
  }

  ngOnInit() {
    if(this.alert_type_2){
      setTimeout(() => {
        this.dialogRef.close();
      }, 3000);
    }
  }

  onDialogClose = () => {
    this.dialogRef.close();
  }
}
